(function() {
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init);  
  function init() {
    moveDescription();
    moveProductTitleOnMobile();
    showBuilder();
    hidePreloader();
    sliderInit();
    
  }

  function moveDescription() {
    const panelsContainer = document.querySelector('.cpb-panels-container');
    const description = panelsContainer.querySelector('.cpb-product-description');
    if(!description) return;
    panelsContainer.append(description);
  }
  function moveProductTitleOnMobile() {
    if(window.matchMedia('(max-width: 999px)').matches) {
      const title = document.querySelector('.cpb-product-title');
      const actionsContainer = document.querySelector('.cpb-product-actions-container');
      actionsContainer.insertAdjacentElement('afterend', title);
    }
  }
  function hidePreloader() {
    const preloader = document.getElementById("cpb-preloader")
    if(preloader) preloader.style.display = 'none';
  }

  function showBuilder() {
    window.scroll(0, 0);
  }
  
  
  
  function sliderInit() {
    var sliderParents = document.querySelectorAll('.cpb-category-img');
    
    sliderParents.forEach(category => {
      var content = category.querySelector('.cpb-category-content');
      var scrollableEl = content.querySelector('.cpb-option__wrapper');
      let timer;
      
      setScrollableElClasses()
      scrollableEl.addEventListener('scroll', function(e) {
      	clearTimeout(timer);
        timer = setTimeout(function() {
          setScrollableElClasses();
        }, 50);
      });
      
      function setScrollableElClasses() {
        content.classList.remove('no-left-scroll');
        content.classList.remove('no-right-scroll');
        if(scrollableEl.scrollLeft === 0) {
          content.classList.add('no-left-scroll');
        } else if(scrollableEl.scrollWidth - scrollableEl.scrollLeft - scrollableEl.clientWidth < 1) {
          content.classList.add('no-right-scroll');
        }
      }      
            
      var btnPrev = document.createElement('button');
      var btnNext = document.createElement('button');
      
      btnPrev.addEventListener('click', function() {
      	scrollableEl.scrollTo({
          left: scrollableEl.scrollLeft - scrollableEl.clientWidth,
          behavior: 'smooth'
        });
      });
      btnNext.addEventListener('click', function() {
      	scrollableEl.scrollTo({
          left: scrollableEl.scrollLeft + scrollableEl.clientWidth,
          behavior: 'smooth'
        });
      });
      
      

      btnPrev.classList.add('cpb-custom-img-prev');
      btnPrev.setAttribute('aria-label', 'Previous');
      btnPrev.setAttribute('type', 'button');
      btnPrev.innerHTML = '<svg height="14" viewBox="0 0 14 24" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m12.927013 11.5215592-11.3216325-11.32163255c-.26656887-.26656887-.69408498-.26656887-.96065385 0s-.26656887.69408498 0 .96065385l10.83879085 10.8387908-10.83879085 10.8387908c-.26656887.2665689-.26656887.694085 0 .9606538.13076964.1307697.30680568.2011841.47781213.2011841.17100644 0 .34704248-.0653848.47781212-.2011841l11.3216325-11.3216325c.2665689-.2615392.2665689-.694085.0050296-.9556242z" fill="#ffffff" transform="matrix(-1 0 0 1 14 0)"/></svg>';

      btnNext.classList.add('cpb-custom-img-next');
      btnNext.setAttribute('aria-label', 'Next');
      btnNext.setAttribute('type', 'button');
      btnNext.innerHTML = '<svg height="14" viewBox="0 0 14 24" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m12.927013 11.5215592-11.3216325-11.32163255c-.26656887-.26656887-.69408498-.26656887-.96065385 0s-.26656887.69408498 0 .96065385l10.83879085 10.8387908-10.83879085 10.8387908c-.26656887.2665689-.26656887.694085 0 .9606538.13076964.1307697.30680568.2011841.47781213.2011841.17100644 0 .34704248-.0653848.47781212-.2011841l11.3216325-11.3216325c.2665689-.2615392.2665689-.694085.0050296-.9556242z" fill="#ffffff"/></svg>'; 
 	
      content.append(btnPrev)
      content.append(btnNext)
    });
  }
})();

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    var hash = '';
    if(uri.indexOf('#') !== -1 ){
      hash = uri.replace(/.*#/, '#');
      uri = uri.replace(/#.*/, '');
    }

    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    return uri + separator + key + "=" + value + hash;
  }
};

var getProductConfigUrl = function() {
  var configId = window._cpb.saveConfig(null, false);
  var url = updateQueryStringParameter(window.location.href, 'configid', configId);
  console.log(url)
};